import { makePropDecorator } from '../util/decorators';

// tslint:disable:variable-name

export interface Metadata extends Query {
	metadataName: string;
}

export interface Query {
	descendants: boolean;
	first: boolean;
	selector: any;
	filter: (e: Element) => boolean;
}

export abstract class Query {}

export const ComponentRef = makePropDecorator(
	'ComponentRef',
	(selector?: any, data: any = {}) => ({
		selector,
		first: true,
		descendants: false,
		...data,
	}),
	Query
);

export const ComponentRefs = makePropDecorator(
	'ComponentRefs',
	(selector?: any, data: any = {}) => ({
		selector,
		first: false,
		descendants: false,
		...data,
	}),
	Query
);

export const ChildRef = makePropDecorator(
	'ChildRef',
	(selector?: any, data: any = {}) => ({
		selector,
		first: true,
		descendants: true,
		...data,
	}),
	Query
);

export const ChildrenRef = makePropDecorator(
	'ChildrenRef',
	(selector?: any, data: any = {}) => ({
		selector,
		first: false,
		descendants: true,
		...data,
	}),
	Query
);
